import { AxiosError, isAxiosError } from 'axios';
import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

const create = async (uuid: string, data: any): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.post(`./planta?uuid=${uuid}`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Authorization: `${token}`,
			},
		});

		if (response.data) {
			return response.data;
		}

		throw new Error('Erro ao criar planta.');
	} catch (error: any) {
		console.error(error);
		if (error.response && error.response.data && error.response.data.message) {
			throw new Error(error.response.data.message);
		}

		throw new Error(
			(error as { message: string }).message || 'Erro ao criar planta.'
		);
	}
};
const confGrafico = async (uuid: string, data: any): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.post(
			`./secao/grafico/config?uuid=${uuid}`,
			data,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			return response.data;
		}
	} catch (error) {
		console.error(error);
		return new Error(
			(error as { message: string }).message || 'Erro ao criar configurações.'
		);
	}
};

const get = async (
	data: string,
	uuid: string,
	id_planta: string
): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(
			`./secao/grafico?data=${data}&uuid=${uuid}&id_planta=${id_planta}`,
			{
				headers: {
					Authorization: `${token}`,
				},
			}
		);

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao buscar planta.');
	} catch (error) {
		return error;
	}
};

const getAll = async (uuid: string): Promise<any> => {
	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`./plantas?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`,
			},
		});

		if (response.data) {
			return response.data;
		}

		return new Error('Erro ao buscar planta.');
	} catch (error) {
		console.error(error);
		return new Error(
			(error as { message: string }).message || 'Erro ao buscar planta.'
		);
	}
};

export const ServiceSecao = {
	create,
	get,
	getAll,
	confGrafico,
};
